import React from 'react';
import styles from './UserInsightsStatistics.module.scss';
import MessagesPerConversation from './messages-per-conversation/MessagesPerConversation';
import Engagement from './engagemenet/Engagement';
import ConversationLength from './conversation-length/ConversationLength';

const UserInsightsStatistics = ({
  startDate,
  endDate,
  botId,
  snapshotMode,
  botType,
}) => {
  return (
    <div className={styles['user-insights-statistics-container']}>
      <div
        className={`${styles['messages-engagement-container']} ${
          snapshotMode ? styles['snapshot-mode'] : ''
        }`}
      >
        <MessagesPerConversation
          startDate={startDate}
          endDate={endDate}
          botId={botId}
          botType={botType}
        />
        <Engagement
          startDate={startDate}
          endDate={endDate}
          botId={botId}
          botType={botType}
        />
        {snapshotMode && (
          <ConversationLength
            startDate={startDate}
            endDate={endDate}
            botId={botId}
            snapshotMode={snapshotMode}
            botType={botType}
          />
        )}
      </div>
      {!snapshotMode && (
        <ConversationLength
          startDate={startDate}
          endDate={endDate}
          botId={botId}
          snapshotMode={snapshotMode}
          botType={botType}
        />
      )}
    </div>
  );
};

export default UserInsightsStatistics;
